import React from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';

interface IProps {
  value: any;
  separator?: string;
  crossborder: boolean;
  format?: string;
}

const ColoredFormattedNumberForeign = (props: IProps) => {
  if (!props.crossborder) {
    return null;
  }
  return (
    <React.Fragment>
      {props.separator} <FormattedNumber value={props.value ? props.value : 0} format={props.format ? props.format : 'USD'} />
    </React.Fragment>
  );
};

function mapStateToProps(state: any) {
  return {
    crossborder: state.orbita.User.user.user.crossborder || false,
  };
}

export default connect(mapStateToProps)(ColoredFormattedNumberForeign);
